"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var operationRouter = {
  path: '/priceSetting',
  component: _layout.default,
  redirect: '/priceSetting/goodPriceManagement',
  name: 'priceSetting',
  meta: {
    title: '价格',
    icon: 'clipboard',
    roles: ['admin']
  },
  children: [{
    path: 'goodPriceManagement',
    name: 'goodPriceManagement',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/priceSetting/goodPriceManagement'));
      });
    },
    meta: {
      title: '商品调价管理',
      icon: 'clipboard'
    }
  }, {
    path: 'goodPriceApprove',
    name: 'goodPriceApprove',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/priceSetting/goodPriceApprove'));
      });
    },
    meta: {
      title: '商品调价审核',
      icon: 'clipboard'
    }
  }, {
    path: 'priceMonitoring',
    name: 'priceMonitoring',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/priceSetting/priceMonitoring'));
      });
    },
    meta: {
      title: '价格监测',
      icon: 'clipboard',
      roles: ['admin']
    },
    children: [{
      path: 'monitoringScreen',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/priceSetting/priceMonitoring/monitoringScreen'));
        });
      },
      name: 'monitoringScreen',
      meta: {
        title: '监测大屏',
        icon: ''
      }
    }, {
      path: 'monitoringConfig',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/priceSetting/priceMonitoring/monitoringConfig'));
        });
      },
      name: 'monitoringConfig',
      meta: {
        title: '监测配置',
        icon: ''
      }
    }, {
      path: 'competitionProductConfig',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/priceSetting/priceMonitoring/competitionProductConfig'));
        });
      },
      name: 'competitionProductConfig',
      meta: {
        title: '商品竞品配置',
        icon: ''
      }
    }]
  }]
};
var _default = exports.default = operationRouter; //collate